export default __webpack_public_path__ + "static/media/Turtlr-gameplay-screenshot-450px-300px.jpg.e7cbd0c1.webp";